

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({ name: 'wxFabButton' })
export default class WxFabButton extends Vue {
    @Prop(Boolean) private value?: boolean;
    @Prop(Boolean) private disabled?: boolean;
    @Prop(Boolean) private large?: boolean;
    @Prop(Boolean) private xLarge?: boolean;
    @Prop(Boolean) private small?: boolean;
    @Prop(Boolean) private xSmall?: boolean;
    @Prop(Boolean) private hoverRotate?: boolean;

    private click(e: MouseEvent): void {
        this.$emit('click', e);
    }
}
